import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

const FlightList = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 0.75C1.75736 0.75 0.75 1.75736 0.75 3V15C0.75 16.2426 1.75735 17.25 3 17.25H15C16.2426 17.25 17.25 16.2426 17.25 15V3C17.25 1.75735 16.2426 0.75 15 0.75H3ZM2.25 3C2.25 2.58578 2.58578 2.25 3 2.25H15C15.4142 2.25 15.75 2.58579 15.75 3V15C15.75 15.4142 15.4142 15.75 15 15.75H3C2.58579 15.75 2.25 15.4142 2.25 15V3Z"
          fill="black"
        />
        <path
          d="M18.75 6.5C18.75 6.08579 19.0858 5.75 19.5 5.75H20C21.2426 5.75 22.25 6.75735 22.25 8V20C22.25 21.2426 21.2426 22.25 20 22.25H8C6.75735 22.25 5.75 21.2426 5.75 20V19.5C5.75 19.0858 6.08579 18.75 6.5 18.75C6.91421 18.75 7.25 19.0858 7.25 19.5V20C7.25 20.4142 7.58579 20.75 8 20.75H20C20.4142 20.75 20.75 20.4142 20.75 20V8C20.75 7.58579 20.4142 7.25 20 7.25H19.5C19.0858 7.25 18.75 6.91421 18.75 6.5Z"
          fill="black"
        />
        <path
          d="M23.75 11.5C23.75 11.0858 24.0858 10.75 24.5 10.75H25C26.2426 10.75 27.25 11.7574 27.25 13V25C27.25 26.2426 26.2426 27.25 25 27.25H13C11.7574 27.25 10.75 26.2426 10.75 25V24.5C10.75 24.0858 11.0858 23.75 11.5 23.75C11.9142 23.75 12.25 24.0858 12.25 24.5V25C12.25 25.4142 12.5858 25.75 13 25.75H25C25.4142 25.75 25.75 25.4142 25.75 25V13C25.75 12.5858 25.4142 12.25 25 12.25H24.5C24.0858 12.25 23.75 11.9142 23.75 11.5Z"
          fill="black"
        />
      </svg>
    </SvgIcon>
  )
}

export default FlightList
